export const mcUserMessages = {
  dashboard: {
    needSelections: 'Please select program, location and a serving date to begin.',
    noSiteAppMeals: 'The site application schedule has no matching meals for the selected date. Please check the entries above for accuracy. If a serving date is missing, please reach out to your sponsor.'
  },
  countDiff: {
    canMerge: 'Ready to accept changes!',
    cannotMerge: 'You must set all fields before accepting changes.'
  },
  serveMeals: {
    discardCounts: 'Your changes will be lost if you proceed without saving them.',
    unsubmittedCounts: 'Your count has only been saved as a draft. Proceed without submitting it?'
  }
};
